// Single place to translate v3.2 events -> our current tracker
import { track as coreTrack, setContext, initAnalytics } from '../../analytics'
import { EventName as CoreEventName } from '../../client/analytics/events'

type Props = Record<string, unknown>
export type EventName = CoreEventName 
  | 'dashboard_view' | 'generate_plan_click' | 'regenerate_plan_click'
  | 'discover_view' | 'swipe_like' | 'swipe_skip' | 'recipe_open'
  | 'plans_view' | 'plan_open' | 'plan_pdf' | 'plan_reuse'
  | 'pricing_view' | 'trial_start_click'
  | 'discover_create_plan_click'
  | 'assistant_open' | 'assistant_close'
  | 'active_usage'
  | 'manage_billing_opened' | 'dashboard_error'
  | 'plan_limit_blocked'
  | 'profile_macros_limited_shown' | 'profile_macro_toggle'
  | 'weekly_digest_toggled' | 'pdf_format_changed'
  | 'upgrade_clicked' | 'upgrade_initiated'
  | 'recipes_load_more_complete'
  | 'taste_profile_onboarding_start'
  | 'taste_profile_onboarding_complete'
  | 'onboarding_step_completed' | 'onboarding_completed'
  | 'admin_mode_enter' | 'admin_mode_exit'
  | 'dock_nav_click' | 'dock_more_open'
  | 'search_open' | 'search_close' | 'search_query' | 'search_select'
  | 'cooking_mode_started'

export function trackEvent(event: EventName, props: Props = {}) {
  coreTrack(event, props)
}

export { setContext, initAnalytics }
